import { array, string } from '@gogame/schemas';

export const hiddenSchema = array(string()).default([]);
